import React from "react";
import { COLORS } from "../../constants/colors.js";
import { FONTS } from "../../constants/fonts.js";

const styles = {
  button: {
    border: "none",
    borderRadius: 12,
    padding: "16px 24px",
    width: "100%",
    textAlign: "center",
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    fontFamily: FONTS.bold,
    fontSize: 18,
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: COLORS.secondary,
      color: COLORS.primary,
      transform: "scale(1.05)",
      boxShadow: `0 6px 16px rgba(${parseInt(
        COLORS.primary.slice(1, 3),
        16
      )}, ${parseInt(COLORS.primary.slice(3, 5), 16)}, ${parseInt(
        COLORS.primary.slice(5, 7),
        16
      )}, 0.3)`,
    },
    "&:active": {
      transform: "scale(0.95)",
    },
  },
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
    transform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: COLORS.primary,
      color: COLORS.white,
      boxShadow: "none",
    },
  },
  loadingSpinner: {
    border: `3px solid ${COLORS.white}`,
    borderTop: `3px solid ${COLORS.secondary}`,
    borderRadius: "50%",
    width: 24,
    height: 24,
    animation: "spin 1s linear infinite",
    marginRight: 8,
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
};

const CustomButton = ({ title, onPress, style, textStyle, disabled }) => {
  return (
    <button
      onClick={onPress}
      disabled={disabled}
      style={{
        ...styles.button,
        ...(disabled ? styles.disabled : {}),
        ...style,
      }}
    >
      {disabled && <div style={styles.loadingSpinner}></div>}
      <span style={{ ...textStyle, fontFamily: FONTS.bold }}>{title}</span>
    </button>
  );
};

export default CustomButton;
